@if (!isMobile) {
	<p-toast></p-toast>
	<p-confirm-dialog />
	<div class="background">
		<div class="page" [class.page--responsive]="isResponsive()">
			<bas-nav-header></bas-nav-header>
			<div class="content">
				@if (showSideNav()) {
					<div class="side-nav">
						<bas-side-nav-hotlinks></bas-side-nav-hotlinks>
					</div>
				}
				<div class="content-area">
					<router-outlet></router-outlet>
					@if (showMainNav() && canSeeDebugLinks()) {
						<div class="links">
							<a class="defaultLink debugItem"
							   routerLink="/service/uilab-branching-mask.do">UI Lab</a>
						</div>
					}
				</div>
			</div>
			<bas-nav-footer></bas-nav-footer>
		</div>
	</div>
} @else {
	<div class="mobile-page"
		 [class.mobile-login]="isLoginPage()">
		@if (showNavHeader()) {
			<bas-nav-header></bas-nav-header>
		}
		@if (showMobileNav()) {
			<bas-mobile-nav></bas-mobile-nav>
		}
		<router-outlet></router-outlet>
		@if (showNavFooter()) {
			<bas-nav-footer></bas-nav-footer>
		}
	</div>
}
